<template>
  <select v-bind:name="name" class="form-control" v-bind:multiple="multiple"></select>
</template>

<script>
import 'select2/dist/js/select2.min'
import 'select2/dist/css/select2.min.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.min.css'

export default {
  name: 'vSelect2',
  props: {
    name: '',
    label: {
      String,
      required: true
    },
    options: {
      Object,
      required: true
    },
    value: null,
    searchable: {
      Boolean,
      default: false
    },
    clearable: {
      Boolean,
      default: false
    },
    multiple: {
      Boolean,
      default: false
    },
    placeholder: {
      String,
      default: 'Choose something ...'
    },
    dropdownParent: {
      String,
      default: null
    }
  },
  watch: {
    options: function (options) {
      this.formatOptions()
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    let vm = this
    let select = $(this.$el)

    let params = {
      placeholder: this.placeholder,
      theme: 'bootstrap',
      width: '100%',
      allowClear: this.clearable,
      dropdownParent: this.dropdownParent
    }

    params.minimumResultsForSearch = this.searchable === false ? Infinity : 1

    if (this.dropdownParent !== null) {
      params.dropdownParent = $('#' + this.dropdownParent)
    }

    select
      .select2(params)
      .on('change', () => {
        let value

        if (this.multiple === true) {
          value = []
          select.val().forEach((id) => {
            let tmpValue = this.options.find((option) => {
              return option.id === parseInt(id)
            })

            if (typeof tmpValue !== 'undefined') {
              value.push(tmpValue)
            }
          })
        } else {
          value = this.options.find((option) => {
            return option.id === parseInt(select.val())
          })
        }

        if (typeof value === 'undefined') {
          value = null
        }

        vm.$emit('input', value)
      })
    this.formatOptions()
  },
  methods: {
    formatOptions () {
      // let select2data = []

      $(this.$el).children().remove()

      for (let key in this.options) {
        let value
        let id
        let disabled
        if (typeof this.options[key][this.label] !== 'undefined') {
          value = this.options[key][this.label]
        } else {
          value = this.options[key]
        }

        if (typeof this.options[key][this.label] !== 'undefined') {
          id = this.options[key].id
        } else {
          id = key
        }

        if (typeof this.options[key]['disabled'] !== 'undefined') {
          disabled = this.options[key].disabled
        } else {
          disabled = false
        }

        if (!$(this.$el).find("option[value='" + id + "']").length) {
          let newOption = new Option(value, id, true, true)
          newOption.disabled = disabled

          $(this.$el).append(newOption)
        }
      }
      if (this.value !== null && typeof this.value === 'object') {
        if (typeof this.value.id !== 'undefined') {
          $(this.$el).val(this.value.id)
        } else {
          let val = []
          this.value.forEach((element) => {
            val.push(element.id)
          })
          $(this.$el).val(val)
          // this.$emit('input', this.value)
        }
      } else {
        $(this.$el).val(this.value)
      }
    }
  },
  destroyed: function () {
    if ($(this.$el).data('select2')) {
      $(this.$el).off().select2('destroy')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/select2.vue